/**
 * LanguageSwitcher — dropdown to change the app language.
 *
 * Calls i18n.changeLanguage() on change. Persistence handled
 * automatically by i18next-browser-languagedetector (localStorage).
 */

import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
];

export const LanguageSwitcher = ({ className }: { className?: string }) => {
  const { i18n } = useTranslation();

  return (
    <select
      className={`form-select ${className ?? ''}`}
      value={i18n.language}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      aria-label="Language"
    >
      {LANGUAGES.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.label}
        </option>
      ))}
    </select>
  );
};
